import { ElementController, getData } from 'js-common';

/**
 * Controller for adding and starting an embedded video player overlay.
 *
 * @extends ElementController
 */
export default class VideoOverlay extends ElementController {
  static id = 'VideoOverlay';

  /** @type {HTMLButtonElement} */
  playButton;

  /** @type {string} */
  embedHtml = '';

  /**
   * DOM loaded.
   */
  init() {
    this.playButton = this.selectSingle('video-overlay-play');
    this.embedHtml = getData(this.root, 'video-overlay-html');

    this.on(this.playButton, 'click', this.handlePlayClick);
    this.on(this.root, 'click', 'video-overlay-close', this.handleCloseClick);
  }

  destroy() {
    this.off(this.playButton, 'click', this.handlePlayClick);
  }

  handlePlayClick = () => {
    const tpl = document.createElement('template');
    tpl.innerHTML = this.embedHtml;
    this.root.append(tpl.content);
    setTimeout(() => {
      this.selectSingle('iframe')?.focus();
    }, 50);
  };

  handleCloseClick = () => {
    const overlay = this.selectSingle('video-overlay');
    if (overlay) {
      overlay.remove();
      this.playButton.focus();
    }
  };
}
